Object.defineProperty(exports, "__esModule", { value: true });
var filter_1 = require("../filter");
/**
 * @returns {(target: Newable<LogAppender>) => void}
 * @constructor
 */
function Filter(name) {
    return function (target) {
        filter_1.addFilter(target, name);
        return target;
    };
}
exports.Filter = Filter;
